import { BaseClient } from '../BaseClient';
import { CustomerPriority, CustomerPriorityList } from '../compiled-protos/user';
import { UserServiceClient } from '../compiled-protos/user.client';

class CustomerPriorityClient extends BaseClient {
  self: UserServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new UserServiceClient(this.transport);
  }

  public async Create(req: CustomerPriority) {
    return await this.self.createCustomerPriority(req, this.getMetaData()).response;
  }

  public async Update(req: CustomerPriority) {
    return await this.self.updateCustomerPriority(req, this.getMetaData()).response;
  }

  public async Delete(req: CustomerPriority) {
    return await this.self.deleteCustomerPriority(req, this.getMetaData()).response;
  }

  public async BatchGet(req: CustomerPriority) {
    return await this.self.batchGetCustomerPriority(req, this.getMetaDataWithoutCache()).response;
  }

  public async listForCustomer(userId: number) {
    const req = CustomerPriority.create({ userId, isActive: 1, withoutLimit: true });
    return await this.BatchGet(req);
  }
}

export { CustomerPriority, CustomerPriorityList, CustomerPriorityClient };
